import { LinkButtonPropTypes } from '../globalUtils/LinkButton/LinkButton'

const BreadCrumbsNavigations: LinkButtonPropTypes[] = [
    {
        linkBtnId: 'text',
        link: '',
        btnText: ''
    },
    {
        linkBtnId: 'dashboard',
        link: '/dashboard',
        btnText: 'Dashboard',
    },
    {
        linkBtnId: 'newDashboard',
        link: '/newDashboard',
        btnText: 'Dashboard',
    },
    {
        linkBtnId: 'alarms',
        link: '/alarms',
        btnText: 'Alarms',
    },
    {
        linkBtnId: 'alarmDetail',
        link: '/alarm?alarmId=',
        btnText: 'Alarm Detail',
    },
    {
        linkBtnId: 'chargers',
        link: '/manage-chargers',
        btnText: 'Chargers',
    },
    {
        linkBtnId: 'chargerDetail',
        link: '/charger?chargerId=',
        btnText: 'Charger Detail',
    },
    {
        linkBtnId: 'addCharger',
        link: '/add-charger',
        btnText: 'Add Charger',
    },
    {
        linkBtnId: 'editCharger',
        link: '/charger-detail',
        btnText: 'Edit Charger',
    },
    {
        linkBtnId: 'viewCharger',
        link: '/charger-detail',
        btnText: 'View Charger',
    },
    {
        linkBtnId: 'setParameters',
        link: '/update-settings',
        btnText: 'Update Settings',
    },
    {
        linkBtnId: 'addUpdateCommands',
        link: '/update-commands',
        btnText: 'Update Commands',
    },
    {
        linkBtnId: 'editSpuriousChargers',
        link: '/spurious-chargers',
        btnText: 'Spurious Chargers',
    },
    {
        linkBtnId: 'customers',
        link: '/customers',
        btnText: 'Customers',
    },
    {
        linkBtnId: 'addCustomer',
        link: '/customer',
        btnText: 'Add Customer',
    },
    {
        linkBtnId: 'editCustomer',
        link: '/customer',
        btnText: 'Edit Customer',
    },
    {
        linkBtnId: 'editChargingStation',
        link: '/station',
        btnText: 'Edit Station',
    },
    {
        linkBtnId: 'chargingStation',
        link: '/charging-stations',
        btnText: 'Charging Station',
    },
    {
        linkBtnId: 'viewCustomer',
        link: '/customer',
        btnText: 'Customer Detail',
    },
    {
        linkBtnId: 'updateHistory',
        link: '/update-history',
        btnText: 'Update History',
    },
    {
        linkBtnId: 'organisations',
        link: '/manage-org',
        btnText: 'Organisations',
    },
    {
        linkBtnId: 'addOrg',
        link: '/org',
        btnText: 'Add Organisation',
    },
    {
        linkBtnId: 'editOrg',
        link: '/org',
        btnText: 'Edit Organisation',
    },
    {
        linkBtnId: 'viewOrg',
        link: '/org',
        btnText: 'Organisation Details',
    },
    {
        linkBtnId: 'users',
        link: '/manage-users',
        btnText: 'Users',
    },
    {
        linkBtnId: 'createNotificationRule',
        link: '/configureNotification',
        btnText: 'Back',
    },
    {
        linkBtnId: 'acCreateNotificationRule',
        link: '/ac/configure-notification',
        btnText: 'Back',
    },
    {
        linkBtnId: 'ruleEngineNewRule',
        link: '/new-rule',
        btnText: 'Back',
    },
    {
        linkBtnId: 'ruleEngineDashboard',
        link: '/rule-engine',
        btnText: 'Back',
    },
    {
        linkBtnId: 'addUser',
        link: '/user',
        btnText: 'Add User',
    },
    {
        linkBtnId: 'editUser',
        link: '/user',
        btnText: 'Edit User',
    },
    {
        linkBtnId: 'viewUser',
        link: '/user',
        btnText: 'User Details',
    },
    {
        linkBtnId: 'roles',
        link: '/roles',
        btnText: 'Roles',
    },
    {
        linkBtnId: 'reports',
        link: '/reports',
        btnText: 'Reports',
    },
    {
        linkBtnId: 'chargingStations',
        link: '/charging-stations',
        btnText: 'Charging Stations',
    },
    {
        linkBtnId: 'addChargingStation',
        link: '/station',
        btnText: 'Add Charging Station',
    },
    {
        linkBtnId: 'ruleEngine',
        link: '/rule-engine',
        btnText: 'Rule List',
    },
    {
        linkBtnId: 'usbCertificates',
        link: '/usb-certificates',
        btnText: 'USB Certificates',
    },
    {
        linkBtnId: 'softwareVersionRelease',
        link:'/manage-software-version-releases',
        btnText:'SW Version Release'
    },
    {
        linkBtnId:'supportCentre',
        link:'/rms-support-center',
        btnText:'Support Center'
    },
    {
        linkBtnId:'helpAndFaq',
        link:'/help-and-faq-dashboard',
        btnText:'Help And FAQ'
    },
    {
        linkBtnId:'documentation',
        link:'/documentation',
        btnText: 'Documentation'
    },
    {
        linkBtnId: 'advanceRuleEngineNewRule',
        link: '/new-rule-advance',
        btnText: 'Back',
    },
    {
        linkBtnId: 'advanceRuleEngineDashboard',
        link: '/rule-engine-advance',
        btnText: 'Back',
    },
    {
        linkBtnId: 'newDerivedCondition',
        link: '/add-derived-condition',
        btnText: 'Back',
    },
    {
        linkBtnId: 'chargerCertificates',
        link: '/charger-certificates',
        btnText: 'Charger Certificates'
    },
    {
        linkBtnId: 'sessionHistoryReport',
        link: '/sessionHistory',
        btnText: 'Session History'
    }

]


export default BreadCrumbsNavigations